var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.25 18.125h-7.5a.627.627 0 0 1-.625-.625v-10c0-.344.281-.625.625-.625h5.473l2.652 2.652V17.5a.627.627 0 0 1-.625.625M13.75 20h7.5c1.379 0 2.5-1.121 2.5-2.5V9.527c0-.496-.2-.972-.55-1.324l-2.65-2.652A1.88 1.88 0 0 0 19.228 5H13.75a2.5 2.5 0 0 0-2.5 2.5v10c0 1.379 1.121 2.5 2.5 2.5m-5-10a2.5 2.5 0 0 0-2.5 2.5v10c0 1.379 1.121 2.5 2.5 2.5h7.5c1.379 0 2.5-1.121 2.5-2.5v-1.25h-1.875v1.25a.627.627 0 0 1-.625.625h-7.5a.627.627 0 0 1-.625-.625v-10c0-.344.281-.625.625-.625H10V10z",
    opacity: 0.32
  })));
};
export default SvgCopy;